import { render, staticRenderFns } from "./DetailFixedAsset.vue?vue&type=template&id=0e379517"
import script from "./DetailFixedAsset.vue?vue&type=script&lang=js"
export * from "./DetailFixedAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports